import { useQuery } from "react-query";
import {
  fetchAlarmNotificationStats,
  fetchAlarmNotificationDeliveries,
} from "../api/NotificationApi";

export const useAlarmNotificationStats = (alarmId) =>
  useQuery(
    ["alarm-notification-stats", alarmId],
    fetchAlarmNotificationStats,
    {
      enabled: !!alarmId,
      staleTime: 30_000,
      refetchInterval: 10_000,
      refetchOnWindowFocus: false,
    }
  );

export const useAlarmNotificationDeliveries = (alarmId) =>
  useQuery(
    ["alarm-notification-deliveries", alarmId],
    fetchAlarmNotificationDeliveries,
    {
      enabled: !!alarmId,
      staleTime: 30_000,
      refetchInterval: 10_000,
      refetchOnWindowFocus: false,
    }
  );
